export const actionCopyEn = {
    next: "Next",
    back: "Back",
    save: "Save",
    send: "Send",
    skip: "Skip",
    skipForNow: "I don't know yet",
    continue: "Continue",
    cancel: "Cancel",
    delete: "Delete",
    submit: "Submit",
    confirm: "Confirm",
    add: "Add",
    edit: "Edit",
    done: "Done",
    stop: "Stop",
    retry: "Retry",
    download: "Download",
    apply: "Apply",
    filter: "Filter",
    filters: "Filters",
    columns: "Columns",
    close: "Close",
    search: "Search",
    more: "More",
    none: "None",
    previous: "Previous",
    rename: "Rename",
    duplicate: "Duplicate",
    share: "Share",
    clearAll: "Clear all",
    clearSearch: "Clear search",
    loading: "Loading...",
    open: "Open",
    invite: "Invite",
    saveCorrection: "Save correction",
    saving: "Saving...",
    sending: "Sending...",
    submitting: "Submitting...",
    skipping: "Skipping...",
    goingBack: "Going back...",
    goingNext: "Going...",
    cancelling: "Cancelling...",
    deleting: "Deleting...",
    deleteConfirmTitle: "Are you absolutely sure?",
    deleteConfirmDescription: "This action cannot be undone.",
    continuing: "Continuing...",
    confirming: "Confirming...",
    adding: "Adding...",
    editing: "Editing...",
    finishing: "Finishing...",
    stopping: "Stopping...",
    retrying: "Retrying...",
    downloading: "Downloading...",
};
